<script lang="ts" setup>
const { t } = useI18n({
  useScope: "local",
});
</script>

<template>
  <footer>
    <div class="references">
      <div class="references-wrapper">
        <div class="references-title">
          <p>{{ t('known_from') }}</p>
        </div>
        <div class="references-items">
          <img src="/assets/images/references/sd.png" alt="Süddeutsche Zeitung" class="brand-carousel-logo">
          <img src="/assets/images/references/faz.png" alt="FAZ" class="brand-carousel-logo img-fluid">
          <img src="/assets/images/references/handelsblatt-logo_350x200.png" alt="Handelsblatt"
            class="brand-carousel-logo">
          <img src="/assets/images/references/berliner-morgenpost-logo_350x200.png" alt="Berliner Morgenpost"
            class="brand-carousel-logo">
          <img src="/assets/images/references/der-tagesspiegel-logo_350x200.png" alt="Der Tagesspiegel"
            class="brand-carousel-logo">
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@import "~/assets/styles/tw-mixins.scss";
$max-image-height: 80px;

.tw-page-footer {
  display: flex;
  flex-flow: column wrap;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;
  margin-top: 2em;

  .tw-page-footer--body {
    position: relative;
    margin-bottom: 1em;
    padding: 3em 1em;

    >* {
      max-width: 1200px;
      margin: 0 auto;
    }
  }

}

.references {
  max-width: 1140px;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  flex: 0 0 auto;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  &-wrapper {
    display: flex;

    margin-right: -15px;
    margin-left: -15px;
    align-items: center !important;
  }

  &-title {
    flex: 0 0 25%;
    max-width: 25%;
    padding: 0 15px;

    p {
      white-space: nowrap;
      font-family: 'Sofia W01', sans-serif;
      line-height: 1.2;
      font-size: 1.25rem;
      font-weight: 700 !important;
      margin: 0;
    }
  }

  &-items {
    display: flex;
    overflow-x: hidden;
    align-items: center;

    img {
      max-height: $max-image-height;
      max-width: 100%;
      padding: 0;
      margin: 0 10px;
    }
  }
}

@media (max-width: 960px) {
  .references {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;

    &-wrapper {
      flex-direction: column;
    }

    &-title {
      max-width: 100%;
      padding: 0;
      margin-bottom: 0.8rem;
    }

    &-items {
      overflow-x: scroll;
      margin: 0 1.5em;
    }
  }
}
</style>

<i18n lang="json">
{
  "de": {
    "known_from": "Bekannt aus:"
  },
  "en": {
    "known_from": "Known from:"
  }
}
</i18n>
